// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1tw10","buttons":"RemoveExpirationActionButtons_buttons__2yz-i"};